import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, ToastHeader, ToastBody, Toast, Alert} from 'reactstrap';
import {confirmAlert} from "react-confirm-alert";
import ReactToPrint from "react-to-print";
import ProductLong from "components/Labels/ProductLong";
import ProductShort from "components/Labels/ProductShort";
import ObjectOverride from "components/ObjectOverride";
import Access from "constants/Access";
import {PrintBarcodeModal} from '../../containers/Print';
import TextField from "@material-ui/core/TextField";
import API from "@beardeddevops/react.api";
import WarningAlert from "../Elements/DispositionPendingWarningAlert";

/**
 *
 */
class DriversLicenseScan extends ObjectOverride {
	constructor(props) {
		super(props, Types.Dispositions_Pendings._name);
		this.initScanners();
		this.scan_error = false;
		this.state.showCustomerConfirmButton = false;
	}

	listening = (event) => {
		if (event.ctrlKey) {
			event.preventDefault();
		}
	}

	componentWillUnmount(){
		document.removeEventListener("keydown", this.listening, false );
	}

	initScanners() {
		if (this.initialized_scanners) return;
		this.initialized_scanners = true;
		let char = null;
		let prevChar = null;
		document.addEventListener("keydown", this.listening, false );
		$(window).keypress(function (e) {
			if (!$(document.activeElement).is("input") &&
				!$(document.activeElement).is("textarea") &&
				!$(document.activeElement).is("select")) {
				if (document.activeElement) {
					$(document.activeElement).blur();
				}
				let key = e.which;
				//do stuff with "key" here...
				prevChar = char;
				char = String.fromCharCode(e.keyCode);
				// enter key

				if(this.props.rootState.account_number === 2291) {
					if (key === 13) {
						this.setState({loading: true})
						setTimeout(() => {
						let scan = this.scanner_current_word;
						if(scan.length < 80) {
						// 	this.setState({scan_error: true})
							return;
						}
						this.processScan(scan);
						this.scanner_current_word = '';
						return;

						}, 1000);
					}
				}
				else {
					if (key === 13 && this.scanner_current_word.length > 79) {
						let scan = this.scanner_current_word + '\n';
						// if (scan.length < 80) {
						// 	this.setState({scan_error: true})
						// 	return;
						// }
						this.processScan(scan);
						this.scanner_current_word = '';
						return;
					}
				}
				this.scanner_current_word += char;
			}
		}.bind(this));

		this.setState({loading: false})
	};

	scanStringUntilNumber = (inputString, startIndex) => {
		const substring = inputString.substring(startIndex);
		const firstNumberIndex = substring.search(/\d/);

		if (firstNumberIndex !== -1) {
			return startIndex + firstNumberIndex;
		}

		return -1;
	}

	scanStringUntilHash = (inputString, startIndex) => {
		const substring = inputString.substring(startIndex);
		const hashIndex = substring.indexOf('#');

		if (hashIndex !== -1) {
			return startIndex + hashIndex;
		}

		return -1;
	}

	/**
	 * @param barcode
	 */
	processScan = async (barcode) => {
		await this.setState({loading: true});
		const suffix_list = ['SR', 'JR', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'XI', 'X'];
		//for test purposes to prove that a loading spinner does exist
		// await new Promise(r => setTimeout(r, 2000));
		 // barcode = '' // Manually set barcodes here for testing


		if(this.props.rootState.account_number === 2291) {
			barcode = barcode.replace('undefined', '')
			// console.log('barcode after split', barcode);
			let splitBarcode = barcode.split(/[\r\n]+(?!.*#)/) // split barcode on new lines into new array
			let formattedBarcode = splitBarcode.map(segment => {
				return segment.replace(/[\r#]/g, ''); // get rid of extra newlines and hashtags
			})
			barcode = barcode.toUpperCase();
			// console.log('this in scan', this);
			this.setState({barcode: barcode})

			let identification_issue = new Date(formattedBarcode[4].substring(4,8), formattedBarcode[4].substring(0,2) - 1, formattedBarcode[4].substring(2,4));
			let identification_expiration = new Date(formattedBarcode[5].substring(4,8), formattedBarcode[5].substring(0,2) - 1, formattedBarcode[5].substring(2,4));
			let birth_date = new Date(formattedBarcode[2].substring(0,4), formattedBarcode[2].substring(4,6) - 1, formattedBarcode[2].substring(6,8));
			let name_first, name_middle, name_last = null;
			let nameParts = formattedBarcode[3].split(',');
			if(nameParts.length >= 4) {
				name_last = nameParts[0];
				name_first = nameParts[1];
				name_middle = nameParts[2] + ' ' + nameParts[3];
				//if anyone has 3 middle names for some reason
				if(nameParts.length > 4) {
					for(let i = 4; i < nameParts.length; i++) {
						name_middle += ' ' + nameParts[i];
					}
				}
			}
			else {
				name_last = nameParts[0];
				name_first = nameParts[1];
				name_middle = nameParts[2];
			}


			//Some heights are stored in inches (070) => 5ft 10 in
			let height_ft = Math.floor(formattedBarcode[12].slice(1,3)/12);
			let height_in = formattedBarcode[12].slice(1,3)%12;

			// Height is in format i.e. '511' => 5'11"
			if(typeof height_ft !== 'number' || height_ft === 0) {
				height_ft = formattedBarcode[12].slice(0,1);
				height_in = formattedBarcode[12].slice(1,3);
			}
			let weight = formattedBarcode[13].split(' ')[0];
			let identification_number = formattedBarcode[0];
			let state = formattedBarcode[1];
			let city = formattedBarcode[6];
			let street_1 = formattedBarcode[7];
			let zip = formattedBarcode[8].slice(0,5);
			let gender = formattedBarcode[10];
			let identification_authority = state;
			let state_of_residence = state;
			this.state.identification_type = 'Drivers License';
				this.setState({
				name_first, name_last, name_middle, weight, street_1, city, state, zip, identification_number, identification_authority,
					gender, birth_date, identification_issue, identification_expiration, height_in, height_ft, state_of_residence
			})
		}


		else {
			barcode = barcode.toUpperCase();
			// console.log('barcode', barcode);
			// console.log('this in scan', this);
			this.setState({barcode: barcode})

			let driversLicenseObject = {};

			//bleh
			if (barcode[19] === 'O' && barcode[20] === 'K') {
				let last_name_end_ndx = barcode.indexOf(',', 29);
				let first_name_end_ndx = barcode.indexOf(',', last_name_end_ndx+1);
				let middle_name_end_ndx = this.scanStringUntilNumber(barcode, first_name_end_ndx+1);
				let expiration_start_ndx = middle_name_end_ndx+8;
				let city_start_ndx = expiration_start_ndx+8;
				let city_end_ndx = this.scanStringUntilNumber(barcode, city_start_ndx);
				let address_end_ndx = this.scanStringUntilHash(barcode, city_end_ndx);
				let birth_date = new Date((barcode.slice(21, 25)), parseInt(barcode.slice(25,27))-1, (barcode.slice(27, 29)));
				let issue_date = new Date((barcode.slice(middle_name_end_ndx+4, middle_name_end_ndx+8)), parseInt(barcode.slice(middle_name_end_ndx, middle_name_end_ndx+2))-1, barcode.slice(middle_name_end_ndx+2, middle_name_end_ndx+4))
				let expiration_date = new Date((barcode.slice(expiration_start_ndx+4, expiration_start_ndx+8)), parseInt(barcode.slice(expiration_start_ndx, expiration_start_ndx+2))-1, barcode.slice(expiration_start_ndx+2, expiration_start_ndx+4))

				this.setState({
					name_first: barcode.slice(last_name_end_ndx+1, first_name_end_ndx),
					name_last: barcode.slice(29, last_name_end_ndx),
					name_middle: barcode.slice(first_name_end_ndx+1, middle_name_end_ndx),
					// weight: driversLicenseObject.weight,
					city: barcode.slice(city_start_ndx, city_end_ndx),
					street_1: barcode.slice(city_end_ndx, address_end_ndx),
					state: 'OK',
					zip: barcode.slice(address_end_ndx+1, address_end_ndx+6),
					identification_number: barcode.slice(9, 19),
					identification_authority: 'OK',
					identification_type: 'Drivers License',
					birth_date: birth_date,
					identification_issue: issue_date,
					identification_expiration: expiration_date
				})
			}
			else {
				// defaults barcode.indexOf('DAI') + 3, barcode.indexOf('DAJ')
				let state_start_ndx = -1;
				let special_year = false;
				let name_first_start_ndx = barcode.indexOf('DAC') + 3;
				let name_first_end_ndx = barcode.indexOf('DDF');
				let name_middle_start_ndx = barcode.indexOf('DAD') + 3;
				let name_middle_end_ndx = barcode.indexOf('DDG');
				let name_last_start_ndx = barcode.indexOf('DCS') + 3;
				let name_last_end_ndx = barcode.indexOf('DDE');
				let name_suffix_start_ndx = barcode.indexOf('DCU') + 3;
				let name_suffix_end_ndx = barcode.indexOf('DAW');
				barcode.indexOf('DAJ') !== -1 ? state_start_ndx = barcode.indexOf('DAJ') + 3 : state_start_ndx = barcode.indexOf('DAO') + 3;
				let height_start_ndx = barcode.indexOf('DAU') + 3;
				let height_end_ndx = barcode.indexOf('DAY');
				let weight_end_ndx = barcode.indexOf('DCK');
				let drivers_license_start_ndx = barcode.indexOf('DAQ') + 3;
				let street_address_start_ndx = barcode.indexOf('DAG') + 3;
				let street_address_end_ndx = barcode.indexOf('DAI');
				let street_address_2_start_ndx = barcode.indexOf('DAM') + 3;
				let street_address_2_end_ndx = barcode.indexOf('DAN')
				let city_start_ndx = barcode.indexOf('DAI') + 3;
				let city_end_ndx = barcode.indexOf('DAJ');
				let drivers_license_end_ndx = barcode.indexOf('DCS');
				let zip_start_ndx = barcode.indexOf('DAK') + 3;
				let issue_date_end_ndx = barcode.indexOf('DBB');
				let zip_code_end_ndx = barcode.indexOf('DCF');
				// console.log('state start', state_start_ndx, barcode.slice(state_start_ndx, state_start_ndx + 5))
				// console.log('slice', barcode.slice(state_start_ndx, state_start_ndx +2))
				let birthdate_end_ndx = barcode.indexOf('DBA');
				let currentState = barcode.slice(state_start_ndx, state_start_ndx + 2);
				let expiration_date_end_ndx = barcode.indexOf('DBC');

				// console.log('curr', currentState)
				let skipFirst = false;
				let inches_for_height = true;
				let skipMiddle = false;
				let skipLast = false;
				let yearFirst = true;

				const stateAbbreviations = [
					"AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
					"HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
					"MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
					"NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
					"SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
				];

				if (stateAbbreviations.includes(currentState)) {


					if (currentState === 'AK') {
						name_first_end_ndx = barcode.indexOf('DAD');
						name_last_end_ndx = barcode.indexOf('DAC');
						weight_end_ndx = barcode.indexOf('DAG');
						name_middle_end_ndx = barcode.indexOf('DCU');
						yearFirst = false;
						drivers_license_end_ndx = barcode.indexOf('DCF');
						height_end_ndx = barcode.indexOf('DAW');
						weight_end_ndx = barcode.indexOf('DAG');
						birthdate_end_ndx = barcode.indexOf('DDJ');
					}


					if (currentState === 'AZ') {

						// Matt's License (Firearm license?)
						if (barcode.indexOf('DDF') === -1) {
							inches_for_height = false;
							height_end_ndx = barcode.indexOf('DAW');
							weight_end_ndx = barcode.indexOf('DAZ');
							drivers_license_end_ndx = barcode.indexOf('DAA');
							issue_date_end_ndx = barcode.indexOf('DBE');
							zip_code_end_ndx = barcode.indexOf('DBB');
							name_first_end_ndx = barcode.indexOf('DAD');
							name_middle_end_ndx = barcode.indexOf('DAG');
							name_last_start_ndx = barcode.indexOf('DAB') + 3;
							name_last_end_ndx = barcode.indexOf('DAC');
						} else {
							//Drivers License
							weight_end_ndx = barcode.indexOf('DAZ');
							yearFirst = false;
						}
					}

					//removed CO from here and put into yearFirst = false block 4/10/2024
					if (currentState === 'OH' || currentState === 'AL' || currentState === 'ID' || currentState === 'MA') {
						name_first_end_ndx = barcode.indexOf('DAD');
						name_middle_end_ndx = barcode.indexOf('DBD');
						name_last_end_ndx = barcode.indexOf('DAC');
						drivers_license_end_ndx = barcode.indexOf('DCF');
						height_end_ndx = barcode.indexOf('DAG');
						birthdate_end_ndx = barcode.indexOf('DBC');
						yearFirst = false;
						if (currentState === 'ID') {
							weight_end_ndx = barcode.indexOf('DDH')
							drivers_license_end_ndx = barcode.indexOf('DCA');
						} else {
							weight_end_ndx = barcode.indexOf('DDL');
						}
					}


					if (currentState === 'HI' || currentState === 'NV') {
						yearFirst = false;
						height_end_ndx = barcode.indexOf('DAG');
						birthdate_end_ndx = barcode.indexOf('DBC');
					}

					//Washington DC
					if (currentState === 'IA' || currentState === 'DC' || currentState === 'WI' || currentState === 'SC') {
						height_end_ndx = barcode.indexOf('DAG');
						name_first_end_ndx = barcode.indexOf('DAD');
						name_middle_end_ndx = barcode.indexOf('DBD');
						name_last_end_ndx = barcode.indexOf('DAC');
						drivers_license_end_ndx = barcode.indexOf('DCF');
						yearFirst = false;
					}

					if (currentState === 'IA') {
						drivers_license_start_ndx = barcode.indexOf('DCK') + 3;
						drivers_license_end_ndx = barcode.indexOf('DCK') + 12;
					}

					if (currentState === 'IN') {
						weight_end_ndx = barcode.indexOf('DDB');
					}

					if (currentState === 'SC') {
						weight_end_ndx = barcode.indexOf('DDK');
						birthdate_end_ndx = barcode.indexOf('DBC');
					}


					if (currentState === 'KS' || currentState === 'DE') {
						weight_end_ndx = barcode.indexOf('DAH');
						yearFirst = false;
					}

					if (currentState === 'LA') {
						yearFirst = false;
						weight_end_ndx = barcode.indexOf('DDK');
					}


					if (currentState === 'MI' || currentState === 'TX' || currentState === 'NV') {
						if (barcode.indexOf('DCT') === -1) {
							weight_end_ndx = barcode.indexOf('ZTZT');
						} else {
							name_first_start_ndx = barcode.indexOf('DCT') + 3;
							let first_middle = barcode.slice(name_first_start_ndx, barcode.indexOf('DBD'));
							let first = first_middle.split(' ')[0]
							let middle = first_middle.split(' ')[1];
							driversLicenseObject.name_first = first;
							driversLicenseObject.name_middle = middle;
							skipFirst = skipMiddle = true;
							name_last_start_ndx = barcode.indexOf('DCS') + 3;
							name_last_end_ndx = barcode.indexOf('DCT');
						}
						drivers_license_end_ndx = barcode.indexOf('DCF');
						birthdate_end_ndx = barcode.indexOf('DBC');
						yearFirst = false;
					}

					if (currentState === 'MO') {
						name_first_end_ndx = barcode.indexOf('DDF');
						name_middle_end_ndx = barcode.indexOf('DDG');
						name_last_start_ndx = barcode.indexOf('DCS') + 3;
						name_last_end_ndx = barcode.indexOf('DDE');
						yearFirst = false;
					}


					if (currentState === 'MS') {
						//needed for account 2611
						if (barcode.indexOf('DAA') === -1) {
							yearFirst = false;
						} else {
							let first_middle_last = barcode.slice(barcode.indexOf('DAA') + 3, barcode.indexOf('DAY'));
							driversLicenseObject = {
								...driversLicenseObject,
								name_first: first_middle_last.split(',')[1],
								name_middle: first_middle_last.split(',')[2],
								name_last: first_middle_last.split(',')[0]
							};
							skipLast = skipMiddle = skipFirst = true;
							inches_for_height = false;
							height_end_ndx = barcode.indexOf('DAW');
							weight_end_ndx = barcode.indexOf('DBA');
							drivers_license_end_ndx = barcode.indexOf('DAA');
							issue_date_end_ndx = barcode.indexOf('DBH');
							birthdate_end_ndx = barcode.indexOf('DBC');
						}
					}


					if (currentState === 'NY') {
						name_first_start_ndx = barcode.indexOf('DCT') + 3;
						let first_middle = barcode.slice(name_first_start_ndx, barcode.indexOf('DBD'));
						let first = first_middle.split(',')[0]
						let middle = first_middle.split(',')[1];
						name_last_end_ndx = barcode.indexOf('DCT');
						driversLicenseObject.name_first = first;
						driversLicenseObject.name_middle = middle;
						skipFirst = skipMiddle = true;
						yearFirst = false;
						drivers_license_end_ndx = barcode.indexOf('DCF');
						height_end_ndx = barcode.indexOf('DAG');
						inches_for_height = false;
						birthdate_end_ndx = barcode.indexOf('DBC');
					}


					if (currentState === 'OK') {
						yearFirst = false;
						inches_for_height = true;
						weight_end_ndx = barcode.indexOf('DCK');
						issue_date_end_ndx = barcode.indexOf('ZOZO');
						expiration_date_end_ndx = barcode.indexOf('DBA') + 11;
						birthdate_end_ndx = barcode.indexOf('DBB') + 11;
					}

					if (currentState === 'OR') {
						let first_middle_last = barcode.slice(barcode.indexOf('DAA') + 3, barcode.indexOf('DAG'));
						driversLicenseObject = {
							...driversLicenseObject,
							name_first: first_middle_last.split(' ')[1],
							name_middle: first_middle_last.split(' ')[2],
							name_last: first_middle_last.split(',')[0]
						};
						skipLast = skipMiddle = skipFirst = true;
						weight_end_ndx = barcode.indexOf('DBA');
						drivers_license_end_ndx = barcode.indexOf('DAA');
						expiration_date_end_ndx = barcode.indexOf('DBB');
						birthdate_end_ndx = barcode.indexOf('DBC');
						issue_date_end_ndx = barcode.indexOf('ZOZO');
						inches_for_height = false;

					}

					if (currentState === 'NC' && barcode.includes('-') && !barcode.includes("*")) {
						name_first_end_ndx = barcode.indexOf('DAD');
						name_middle_end_ndx = barcode.indexOf('DAE');
						name_last_end_ndx = barcode.indexOf('DAC');
						name_last_start_ndx = barcode.indexOf('DAB') + 3;
						street_address_start_ndx = barcode.indexOf('DAL') + 3;
						street_address_end_ndx = barcode.indexOf('DAM');
						city_start_ndx = barcode.indexOf('DAN') + 3;
						city_end_ndx = barcode.indexOf('DAO');
						special_year = true;
						drivers_license_start_ndx = barcode.indexOf('DAQ') + 3;
						drivers_license_end_ndx = barcode.indexOf('DAR');
						zip_start_ndx = barcode.indexOf('DAP') + 3;
						zip_code_end_ndx = barcode.indexOf('DAP') + 8;

					}
					else if (currentState === 'NC' && barcode.indexOf('DEN') === -1) {
						name_first_end_ndx = barcode.indexOf('DAD');
						name_last_end_ndx = barcode.indexOf('DAC');
						name_middle_end_ndx = barcode.indexOf('DBD');
						drivers_license_start_ndx = barcode.indexOf('DAQ') + 3;
						drivers_license_end_ndx = barcode.indexOf('DCF');
						height_start_ndx = barcode.indexOf('DAU') + 3;
						height_end_ndx = barcode.indexOf('DAG')
						inches_for_height = true;
						birthdate_end_ndx = barcode.indexOf('DBC');
						issue_date_end_ndx = barcode.indexOf('DBB');
						expiration_date_end_ndx = barcode.indexOf('DCS');
						yearFirst = false;
					}
					else if (currentState === 'NC') {
						yearFirst = false;
					}

					// Removed NC from here on 7/27/2023 to accomodate another license from North Carolina
					if (currentState === 'PA' || currentState === 'TN' || currentState === 'AR' || currentState === 'KY'
						|| currentState === 'MT' || currentState === 'MD' || currentState === 'NJ' || currentState === 'ND' || currentState === 'ME'
						|| currentState === 'RI' || currentState === 'IL' || currentState === 'IN' || currentState === 'NM'
						|| currentState === 'CT' || currentState === 'WV' || currentState === 'WY') {
						yearFirst = false;
					}


					if (currentState === 'CO') {
						yearFirst = false;
						weight_end_ndx = barcode.indexOf('ZCZC');
					}

					if (currentState === 'GA') {
						yearFirst = false;
						height_end_ndx = barcode.indexOf('DAG');
						birthdate_end_ndx = barcode.indexOf('DBC');
						drivers_license_end_ndx = barcode.indexOf('DCF');

					}

					if (currentState === 'MN') {
						yearFirst = false;
						street_address_2_start_ndx = barcode.indexOf('DAH') + 3;
						street_address_2_end_ndx = barcode.indexOf('DCK');
						weight_end_ndx = barcode.indexOf('DAH') === -1 ? weight_end_ndx = barcode.indexOf('DCK') : weight_end_ndx = barcode.indexOf('DAH');
					}


					if (currentState === 'MD') {
						weight_end_ndx = barcode.indexOf('ZMZ');
					}

					if (currentState === 'UT' || currentState === 'NE') {
						yearFirst = false;
						weight_end_ndx = barcode.indexOf('DAZ');
					}

					if (currentState === 'SD') {
						name_first_end_ndx = barcode.indexOf('DAD');
						name_middle_end_ndx = barcode.indexOf('DCU');
						name_last_end_ndx = barcode.indexOf('DAC');
						weight_end_ndx = barcode.indexOf('DAZ');
						drivers_license_start_ndx = barcode.indexOf('DAQ') + 3;
						drivers_license_end_ndx = barcode.indexOf('DAW');
						height_end_ndx = barcode.indexOf('DAG');
						yearFirst = false;
					}

					if (currentState === 'VA') {
						name_first_start_ndx = barcode.indexOf('DCT') + 3;
						let first_middle = barcode.slice(name_first_start_ndx, barcode.indexOf('DBD'));
						let first = first_middle.split(',')[0]
						let middle = first_middle.split(',')[1];
						driversLicenseObject.name_first = first;
						driversLicenseObject.name_middle = middle;
						skipFirst = skipMiddle = true;
						name_last_end_ndx = barcode.indexOf('DCT');
						drivers_license_end_ndx = barcode.indexOf('DCF');
						height_end_ndx = barcode.indexOf('DAG');
						birthdate_end_ndx = barcode.indexOf('DBC');
						yearFirst = false;
					}

					if (currentState === 'FL' || currentState === 'TX') {
						height_end_ndx = barcode.indexOf('DAG');
						name_suffix_end_ndx = barcode.indexOf('DCL');
						yearFirst = false;
					}


					if (currentState === 'WA' || currentState === 'VT' || currentState === 'CA') {
						name_first_end_ndx = barcode.indexOf('DAD');
						name_middle_end_ndx = barcode.indexOf('DBD');
						name_last_end_ndx = barcode.indexOf('DAC');
						yearFirst = false;
						weight_end_ndx = barcode.indexOf('DDK');
						height_end_ndx = barcode.indexOf('DAG');
						drivers_license_end_ndx = barcode.indexOf('DCF');

						if (currentState === 'VT') {
							weight_end_ndx = barcode.indexOf('ZVA');
							birthdate_end_ndx = barcode.indexOf('DBC');
						}
					}

					if (currentState === 'CA' || currentState === 'ME' || currentState === 'RI') {
						weight_end_ndx = barcode.indexOf('DAZ');
						birthdate_end_ndx = barcode.indexOf('DBC');
					}

					//Store everything in an object to easily grab later
					driversLicenseObject.state = currentState;
					drivers_license_start_ndx !== 2 ? driversLicenseObject.dl_number = barcode.slice(drivers_license_start_ndx, drivers_license_end_ndx) : driversLicenseObject.dl_number = '';
					!skipLast ? driversLicenseObject.name_last = barcode.slice(name_last_start_ndx, name_last_end_ndx) : null;
					barcode.indexOf('DDE') !== -1 ? driversLicenseObject.name_last_truncated = barcode.slice(barcode.indexOf('DDE') + 3, barcode.indexOf('DAC')) : driversLicenseObject.name_last_truncated = '';
					!skipFirst ? driversLicenseObject.name_first = barcode.slice(name_first_start_ndx, name_first_end_ndx) : null;
					barcode.indexOf('DDF') !== -1 ? driversLicenseObject.name_first_truncated = barcode.slice(barcode.indexOf('DDF') + 3, barcode.indexOf('DAD')) : driversLicenseObject.name_first_truncated = '';
					!skipMiddle ? driversLicenseObject.name_middle = barcode.slice(name_middle_start_ndx, name_middle_end_ndx) : null;
					barcode.indexOf('DDG') !== -1 ? driversLicenseObject.name_middle_truncated = barcode.slice(barcode.indexOf('DDG') + 3, barcode.indexOf('DCA')) : driversLicenseObject.name_middle_truncated = '';
					barcode.indexOf('DCA') !== -1 ? driversLicenseObject.jurisdiction_vehicle_class = barcode.slice(barcode.indexOf('DCA') + 3, barcode.indexOf('DCB')) : driversLicenseObject.jurisdiction_vehicle_class = '';
					barcode.indexOf('DCB') !== -1 ? driversLicenseObject.jurisdiction_restrictions = barcode.slice(barcode.indexOf('DCB') + 3, barcode.indexOf('DCD')) : driversLicenseObject.jurisdiction_restrictions = '';
					barcode.indexOf('DCD') !== -1 ? driversLicenseObject.jurisdiction_endorsements = barcode.slice(barcode.indexOf('DCD') + 3, barcode.indexOf('DBD')) : driversLicenseObject.jurisdiction_endorsements = '';
					barcode.indexOf('DBD') !== -1 ? driversLicenseObject.issue_date = barcode.slice(barcode.indexOf('DBD') + 3, issue_date_end_ndx) : driversLicenseObject.issue_date = '';
					barcode.indexOf('DBB') !== -1 ? driversLicenseObject.date_of_birth = barcode.slice(barcode.indexOf('DBB') + 3, birthdate_end_ndx) : driversLicenseObject.date_of_birth = '';
					barcode.indexOf('DBA') !== -1 ? driversLicenseObject.expiration_date = barcode.slice(barcode.indexOf('DBA') + 3, expiration_date_end_ndx) : driversLicenseObject.expiration_date = '';
					barcode.indexOf('DBC') !== -1 ? driversLicenseObject.gender = barcode.slice(barcode.indexOf('DBC') + 3, barcode.indexOf('DBC') + 4) : driversLicenseObject.gender = '';
					height_start_ndx !== 2 ? driversLicenseObject.height = barcode.slice(height_start_ndx, height_end_ndx) : driversLicenseObject.height = '';
					barcode.indexOf('DAY') !== -1 ? driversLicenseObject.eye_color = barcode.slice(barcode.indexOf('DAY') + 3, barcode.indexOf('DAG')) : driversLicenseObject.eye_color = '';
					street_address_start_ndx !== -1 ? driversLicenseObject.street_address = barcode.slice(street_address_start_ndx, street_address_end_ndx) : driversLicenseObject.street_address = '';
					city_start_ndx !== 2 ? driversLicenseObject.city = barcode.slice(city_start_ndx, city_end_ndx) : driversLicenseObject.city = '';
					zip_start_ndx !== 2 ? driversLicenseObject.zip_code = barcode.slice(zip_start_ndx, zip_code_end_ndx) : driversLicenseObject.zip_code = '';
					barcode.indexOf('DCF') !== -1 ? driversLicenseObject.document_discriminator = barcode.slice(barcode.indexOf('DCF') + 3, barcode.indexOf('DCG')) : driversLicenseObject.document_discriminator = '';
					barcode.indexOf('DCG') !== -1 ? driversLicenseObject.country = barcode.slice(barcode.indexOf('DCG') + 3, barcode.indexOf('DAW')) : driversLicenseObject.country = '';
					barcode.indexOf('DAW') !== -1 ? driversLicenseObject.weight = barcode.slice(barcode.indexOf('DAW') + 3, weight_end_ndx) : driversLicenseObject.weight = '';
					barcode.indexOf('DCK') !== -1 ? driversLicenseObject.inventory_control_number = barcode.slice(barcode.indexOf('DCK') + 3, barcode.indexOf('DDA')) : driversLicenseObject.inventory_control_number = '';
					barcode.indexOf('DDA') !== -1 ? driversLicenseObject.compliance_type = barcode.slice(barcode.indexOf('DDA') + 3, barcode.indexOf('DDB')) : driversLicenseObject.compliance_type = '';
					barcode.indexOf('DDB') !== -1 ? driversLicenseObject.card_revision_date = barcode.slice(barcode.indexOf('DDB') + 3, barcode.indexOf('DDK')) : driversLicenseObject.card_revision_date = '';
					barcode.indexOf('DDK') !== -1 ? driversLicenseObject.inventory_control_number = barcode.slice(barcode.indexOf('DDK') + 3, barcode.indexOf('DDK') + 4) : driversLicenseObject.inventory_control_number = '';
					street_address_2_start_ndx !== 2 ? driversLicenseObject.street_2 = barcode.slice(street_address_2_start_ndx, street_address_2_end_ndx) : driversLicenseObject.street2 = '';
					(name_suffix_start_ndx !== -1 && name_suffix_end_ndx !== -1) && suffix_list.includes(barcode.slice(name_suffix_start_ndx, name_suffix_end_ndx)) ? driversLicenseObject.name_suffix = barcode.slice(name_suffix_start_ndx, name_suffix_end_ndx) : driversLicenseObject.name_suffix = '';
					this.setState({driversLicenseObject})
					//based on ID formats - different formats for storing dates
					let birth_date
					//based on ID formats - different formats for storing dates
					if (!yearFirst) {
						let issue_month = (driversLicenseObject.issue_date.slice(0, 2) - 1);
						let issue_day = driversLicenseObject.issue_date.slice(2, 4);
						let issue_year = driversLicenseObject.issue_date.slice(4, 8);
						let expiration_month = (driversLicenseObject.expiration_date.slice(0, 2) - 1);
						let expiration_day = driversLicenseObject.expiration_date.slice(2, 4);
						let expiration_year = driversLicenseObject.expiration_date.slice(4, 8);
						let birth_month = (driversLicenseObject.date_of_birth.slice(0, 2) - 1);
						let birth_day = driversLicenseObject.date_of_birth.slice(2, 4);
						let birth_year = driversLicenseObject.date_of_birth.slice(4, 8);
						let identification_issue = new Date(issue_year, issue_month, issue_day);
						let identification_expiration = new Date(expiration_year, expiration_month, expiration_day);
						birth_date = new Date(birth_year, birth_month, birth_day);
						this.setState({identification_issue, identification_expiration, birth_date})
					} else if (!special_year) {
						let issue_month = (driversLicenseObject.issue_date.slice(4, 6) - 1);
						let issue_day = driversLicenseObject.issue_date.slice(6, 8);
						let issue_year = driversLicenseObject.issue_date.slice(0, 4);
						let expiration_month = (driversLicenseObject.expiration_date.slice(4, 6) - 1);
						let expiration_day = driversLicenseObject.expiration_date.slice(6, 8);
						let expiration_year = driversLicenseObject.expiration_date.slice(0, 4);
						let birth_month = (driversLicenseObject.date_of_birth.slice(4, 7) - 1);
						let birth_day = driversLicenseObject.date_of_birth.slice(6, 8);
						let birth_year = driversLicenseObject.date_of_birth.slice(0, 4);

						birth_date = new Date(birth_year, birth_month, birth_day);
						let identification_issue = new Date(issue_year, issue_month, issue_day);
						let identification_expiration = new Date(expiration_year, expiration_month, expiration_day);
						this.setState({identification_issue, identification_expiration, birth_date})
					} else {
						//NC special dates with dashes in it
						birth_date = new Date((barcode.slice(barcode.indexOf('DBB') + 9, barcode.indexOf('DBB') + 13)), (barcode.slice(barcode.indexOf('DBB') + 3, barcode.indexOf('DBB') + 5)) - 1, barcode.slice(barcode.indexOf('DBB') + 6, barcode.indexOf('DBB') + 8));
						let identification_issue = new Date((barcode.slice(barcode.indexOf('DBD') + 9, barcode.indexOf('DBD') + 13)), (barcode.slice(barcode.indexOf('DBD') + 3, barcode.indexOf('DBD') + 5)) - 1, barcode.slice(barcode.indexOf('DBD') + 6, barcode.indexOf('DBD') + 8));
						let identification_expiration = new Date((barcode.slice(barcode.indexOf('DBA') + 9, barcode.indexOf('DBA') + 13)), (barcode.slice(barcode.indexOf('DBA') + 3, barcode.indexOf('DBA') + 5)) - 1, barcode.slice(barcode.indexOf('DBA') + 6, barcode.indexOf('DBA') + 8));
						this.setState({identification_issue, identification_expiration, birth_date})
					}


					driversLicenseObject.zip_code.slice(-1) === '0' ? driversLicenseObject.zip_code = driversLicenseObject.zip_code.slice(0, 5) : null


					let gender = driversLicenseObject.gender === '1' ? 'M' : 'F';
					//static info for both DL formats

					this.setState({
						name_first: driversLicenseObject.name_first,
						name_last: driversLicenseObject.name_last,
						name_middle: driversLicenseObject.name_middle !== '' && driversLicenseObject.name_middle !== null ? driversLicenseObject.name_middle : 'NMN',
						name_suffix: driversLicenseObject.name_suffix,
						weight: driversLicenseObject.weight,
						street_1: driversLicenseObject.street_address,
						street_2: driversLicenseObject.street_2,
						city: driversLicenseObject.city,
						state: driversLicenseObject.state,
						zip: driversLicenseObject.zip_code.substr(0, 5),
						identification_number: driversLicenseObject.dl_number,
						identification_authority: driversLicenseObject.state,
						identification_type: 'Drivers License',
						birth_date: birth_date,
						gender: gender
					})

					//Some heights are stored in inches (070 in): 5ft 10 in -- some are stored in feet/inches (510): 5ft 10in
					if (!inches_for_height) {
						this.setState({
							height_ft: driversLicenseObject.height[0],
							height_in: driversLicenseObject.height.slice(1, 3)
						})
					} else {
						this.setState({
							height_ft: Math.floor(driversLicenseObject.height.slice(1, 3) / 12),
							height_in: driversLicenseObject.height.slice(1, 3) % 12
						})
					}
				}
			}
			}


		await this.setState({
			key: Math.random(),
			loading: false,
			showCustomerConfirmButton: true
		})
	}

	handleSubmit() {
		let DLmodel = new API.BuildClass(Types.Dispositions_Pendings._name, API.RequestType.UPDATE);
		this.state.dl_scan_toggle = false;
		DLmodel.submit(this, API.RequestType.UPDATE, null, true);
		this.props.mytoggle();
	}

	ignoreWarning = (warningName) => () => {
		this.setState({
			[warningName]: false
		});
	};


	handleFormClear = async () => {
		this.setState({
			name_first: null,
			name_last: null,
			name_middle: null,
			weight: null,
			street_1: null,
			city: null,
			state: null,
			zip: null,
			identification_number: null,
			identification_authority: null,
			identification_type: null,
			height_ft: null,
			height_in: null,
			identification_issue: null,
			identification_expiration: null,
			birth_date: null,
			showCustomerConfirmButton: false
		})


		let scan_log_model = new API.BuildClass(Types.Drivers_License_Logs._name, API.RequestType.CREATE);
		scan_log_model.object.user_scan = this.state.barcode;
		scan_log_model.object.collection_binary_id = this.state._id.split('-')[0];
		scan_log_model.object.collection = this.state._id.split('-')[1];

		try {
			await scan_log_model.submit(null, API.RequestType.CREATE, true);
		}
		catch (e) {

		}
		this.state.barcode = '';
	}

	handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			//blur the field that scanned, which results in the scanning code being ran
			e.target.blur();
		}
	}


	form = () => {
		/** @type {Dispositions_Pendings_Properties} properties */
		let properties = this.model.properties;
		/** @type {Dispositions_Pendings_Object} object */
		let object = this.state;
		let {loading} = this.state;
		let exists = object.pkey;
		return (
			<div>

				<Alert color="warning">
					If there are two barcodes on your identification, try covering up the smaller barcode so it does not accidentally scan.
				</Alert>
				<fieldset>
					<div className={"row"}>
						<div className={"col-md"}>
							{/*#region ATF Regulated Information*/}
							<h4 className="section-title">Name Information</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"First Name"}
									value={object.name_first}
									error={object.name_first_error}
									property={properties.name_first}
									update={this.handleTextFieldPropertyUpdate}
									onKeyDown={this.handleKeyDown}
								/>
							</div>
								<div className="form-group">
									<Framework.Elements.TextField
										label={"Middle Name"}
										property={properties.name_middle}
										value={object.name_middle}
										error={object.name_middle_error}
										update={this.handleTextFieldPropertyUpdate}
										onKeyDown={this.handleKeyDown}
									/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Last Name"}
									value={object.name_last}
									error={object.name_last_error}
									property={properties.name_last}
									update={this.handleTextFieldPropertyUpdate}
									onKeyDown={this.handleKeyDown}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.Select
									label={"Suffix"}
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									objects={[
										{pkey: 'SR', name: 'Sr'},
										{pkey: 'JR', name: 'Jr'},
										{pkey: 'II', name: 'II'},
										{pkey: 'III', name: 'III'},
										{pkey: 'IV', name: 'IV'},
										{pkey: 'V', name: 'V'},
										{pkey: 'VI', name: 'VI'},
										{pkey: 'VII', name: 'VII'},
										{pkey: 'VIII', name: 'VIII'},
										{pkey: 'IX', name: 'IX'},
										{pkey: 'X', name: 'X'},
									]}
									property={properties.name_suffix}
									value={object.name_suffix}
									error={object.name_suffix_error}
									text={'name'}
									nullable={true}
									limit={null}
									// disabled={!!disabledParts}
								/>
							</div>
							{/*#endregion*/}
							{/*#region Inventory Management*/}
							<h4 className="section-title">Height/Weight</h4>
							<div className={"row"}>
								<div className={"col-md-4"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Height FT"}
											value={object.height_ft}
											error={object.height_ft_error}
											property={properties.height_ft}
											update={this.handleTextFieldPropertyUpdate}
											onKeyDown={this.handleKeyDown}
										/>
									</div>
								</div>
								<div className={"col-md-4"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Height IN"}
											value={object.height_in}
											error={object.height_in_error}
											property={properties.height_in}
											update={this.handleTextFieldPropertyUpdate}
											onKeyDown={this.handleKeyDown}
										/>
									</div>
								</div>
								<div className={"col-md-4"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Weight"}
											value={object.weight}
											error={object.weight_error}
											property={properties.weight}
											update={this.handleTextFieldPropertyUpdate}
											onKeyDown={this.handleKeyDown}
										/>
									</div>
								</div>
							</div>
							<h4 className="section-title">Birth Date & Gender</h4>
							<div className={"row"}>
								<div className={"col-md-6"}>
									<div className={"form-group"}>
										<Framework.Elements.Date
											label={"Birth Date"}
											value={object.birth_date}
											error={object.birth_date_error}
											property={properties.birth_date}
											update={this.handleTextFieldPropertyUpdate}
											onKeyDown={this.handleKeyDown}
										/>
									</div>
								</div>
								<div className="col-md-6">
									<Framework.Elements.Select
										shouldLoad={this.state.loaded}
										update={this.handleSelectPropertyUpdate}
										objects={[
											{pkey: 'M', name: 'Male'},
											{pkey: 'F', name: 'Female'},
											{pkey: 'O', name: 'Non-Binary'},
										]}
										property={properties.gender}
										value={object.gender}
										error={object.gender_error}
										text={'name'}
										nullable={false}
										limit={null}
									/>
								</div>
							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Notes (Field 32 of 4473)"}
									value={object.notes}
									error={object.notes_error}
									property={properties.notes}
									update={this.handleTextFieldPropertyUpdate}
									onKeyDown={this.handleKeyDown}
									multiline={4}
								/>
							</div>

							{this.state.showCustomerConfirmButton && <div>
								<Button color="warning" onClick={this.handleFormClear}>This Doesn't Look Right (Clear)</Button>
							</div>
							}
							{/*#endregion*/}

						</div>

						<div className={"col-md"}>
							{/*#region ATF Required Information*/}
							<h4 className="section-title">Address</h4>
							<div className={"row"}>
								<div className={"col-12"}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.street_1}
											value={object.street_1}
											error={object.street_1_error}
											update={this.handleTextFieldPropertyUpdate}
											onKeyDown={this.handleKeyDown}
										/>
									</div>
								</div>
							</div>
							<div className={"row"}>
								<div className={"col-12"}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.street_2}
											value={object.street_2}
											error={object.street_2_error}
											update={this.handleTextFieldPropertyUpdate}
											onKeyDown={this.handleKeyDown}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.city}
									value={object.city}
									error={object.city_error}
									update={this.handleTextFieldPropertyUpdate}
									onKeyDown={this.handleKeyDown}
								/>
							</div>
							<div className={"row"}>
								<div className={"col-4"}>
									<div className="form-group">
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											property={properties.state}
											value={object.state}
											error={object.state_error}
											id={'short'}
											model={Types.States._name}
											nullable={true}
											limit={null}
										/>
									</div>
								</div>
								<div className={"col-8"}>
									<div className="form-group">
										<Framework.Elements.ZipCode
											property={properties.zip}
											value={object.zip}
											error={object.zip_error}
											update={this.handleTextFieldPropertyUpdate}
											onKeyDown={this.handleKeyDown}
										/>
									</div>
								</div>
							</div>
							{/*#endregion*/}
							<h4 className="section-title">Drivers License Number</h4>
							<div className={"row"}>
								<div className={"col-md-12"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"DL Number"}
											value={object.identification_number}
											error={object.identification_number_error}
											property={properties.identification_number}
											update={this.handleTextFieldPropertyUpdate}
											onKeyDown={this.handleKeyDown}
										/>
									</div>
								</div>
							</div>
							<h4 className="section-title">Drivers License Expiration</h4>
							<div className={"row"}>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.Date
											label={"Issue Date"}
											value={object.identification_issue}
											error={object.identification_issue_error}
											property={properties.identification_issue}
											update={this.handleTextFieldPropertyUpdate}
											onKeyDown={this.handleKeyDown}
										/>
									</div>
								</div>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.Date
											label={"Expiration Date"}
											value={object.identification_expiration}
											error={object.identification_expiration_error}
											property={properties.identification_expiration}
											update={this.handleTextFieldPropertyUpdate}
											onKeyDown={this.handleKeyDown}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>
				<CardActions style={{justifyContent: 'flex-end', padding: '14px'}}>
					<Button color="primary" onClick={this.handleModalToggle}>Save
					</Button>
				</CardActions>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(DriversLicenseScan);
